"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualTaskViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class ManualTaskViewModel extends ActivityViewModel_1.ActivityViewModel {
    constructor(manualTask, processModel) {
        super(manualTask, processModel);
        this.requiresConfirmation = manualTask.requiresConfirmation;
    }
}
exports.ManualTaskViewModel = ManualTaskViewModel;
//# sourceMappingURL=ManualTaskViewModel.js.map